import {
  GET_ONBOARDING_SUCCESSFUL,
  GET_PREFERENCES_SUCCESSFUL,
  GET_USERS_SUCCESSFUL,
  SEARCH_USER_SUCCESSFUL,
  GET_ADMIN_ROLES_SUCCESSFUL,
  GET_PERMISSIONS,
  GET_ADMIN_USER_SUCCESSFULL,
} from 'redux/actions/Users';

const initialState = {
  users: [],
  search_user: {},
  onboarding: [],
  preferences: [],
  roles: [],
  permissions: [],
  adminUser: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_SUCCESSFUL:
      return { ...state, users: action.payload };
    case SEARCH_USER_SUCCESSFUL:
      return { ...state, search_user: action.payload };
    case GET_ONBOARDING_SUCCESSFUL:
      return { ...state, onboarding: action.payload };
    case GET_PREFERENCES_SUCCESSFUL:
      return { ...state, preferences: action.payload };
    case GET_ADMIN_ROLES_SUCCESSFUL:
      return { ...state, roles: action.payload };
    case GET_PERMISSIONS:
      return { ...state, permissions: action.payload };
    case GET_ADMIN_USER_SUCCESSFULL:
      let newUser = { ...state.adminUser }
      newUser[action.id] = action.payload 
      return { ...state, adminUser: newUser };
    default:
      return state;
  }
};
